// const getFileToDownload = (state) => {
//   return state.fileToDownload;
// };

export default {};